import { useEffect, useState } from "react";
import { api } from "../api";
import { navigate } from "../router";
import { ErrorCard, Loading } from "./Profile";

interface Row {
  rank: number;
  username: string | null;
  firstName: string | null;
  games: number;
  wins: number;
  losses: number;
  winRate: number;
  rating: number;
}

const MEDAL = ["🥇", "🥈", "🥉"];

export function LeaderboardPage() {
  const [rows, setRows] = useState<Row[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.leaderboard().then((r) => setRows(r.leaderboard)).catch((e: Error) => setError(e.message));
  }, []);

  if (error) return <ErrorCard message={error} />;
  if (!rows) return <Loading />;

  return (
    <div className="screen">
      <header className="header">
        <h1>🏆 جدول امتیازات</h1>
      </header>
      <div className="card">
        {rows.length === 0 && <p className="muted center">هنوز بازی‌ای انجام نشده است.</p>}
        {rows.map((r) => (
          <div key={r.rank} className="lb-row">
            <span className="lb-rank">{MEDAL[r.rank - 1] ?? `#${r.rank}`}</span>
            <span className="lb-name">{r.firstName ?? r.username ?? "بازیکن"}</span>
            <span className="lb-stats muted">
              {r.wins} برد / {r.games} بازی
            </span>
            <span className="lb-rating" dir="ltr">{r.rating}</span>
          </div>
        ))}
      </div>
      <button className="btn block" onClick={() => navigate("home")}>🏠 بازگشت</button>
    </div>
  );
}
